
import React from 'react';
import { Card } from '@/components/ui/card';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

const TopLists = ({ analytics }: { analytics: any }) => (
  <div className="grid grid-cols-1 xl:grid-cols-2 gap-6">
    <Card className="p-6">
      <h3 className="text-lg font-semibold mb-4">Top Performing Games (Real Plays)</h3>
      <div className="space-y-3">
        {analytics?.topGames?.slice(0, 8).map((game: any, index: number) => (
          <div key={game.id} className="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
            <div className="flex items-center space-x-3">
              <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center text-blue-600 font-semibold text-sm">
                {index + 1}
              </div>
              <div>
                <p className="font-medium text-gray-900 text-sm">{game.title}</p>
                <p className="text-xs text-gray-600">{game.category}</p>
              </div>
            </div>
            <div className="text-right">
              <p className="font-semibold text-green-600">{game.real_play_count.toLocaleString()}</p>
              <p className="text-xs text-purple-500">({game.display_play_count.toLocaleString()} shown)</p>
            </div>
          </div>
        )) || []}
      </div>
    </Card>

    <Card className="p-6">
      <h3 className="text-lg font-semibold mb-4">Category Real vs Display Performance</h3>
      <ResponsiveContainer width="100%" height={300}>
        <BarChart data={analytics?.categoryStats}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis />
          <Tooltip />
          <Bar dataKey="real_plays" fill="#10B981" name="Real Plays" />
          <Bar dataKey="display_plays" fill="#8B5CF6" name="Display Plays" />
        </BarChart>
      </ResponsiveContainer>
    </Card>
  </div>
);

export default TopLists;
